import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import { Stack, Switch, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useResolvedThemeMode } from "@/theme/systemTheme";
import { useThemePreferenceStore } from "@/theme/themeStore";

export function ThemeModeControl() {
  const { t } = useTranslation();
  const preference = useThemePreferenceStore((state) => state.preference);
  const setPreference = useThemePreferenceStore((state) => state.setPreference);
  const resolvedMode = useResolvedThemeMode();
  const checked = resolvedMode === "dark";
  const currentLabel =
    preference === "system"
      ? `Sistema (${resolvedMode === "dark" ? "escuro" : "claro"})`
      : resolvedMode === "dark"
        ? "Escuro"
        : "Claro";

  const handleSwitch = () => {
    setPreference(resolvedMode === "dark" ? "light" : "dark");
  };

  return (
    <Tooltip title={`Tema atual: ${currentLabel}`}>
      <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
        <LightModeRoundedIcon fontSize="small" aria-hidden />
        <Switch
          checked={checked}
          onChange={handleSwitch}
          slotProps={{ input: { "aria-label": `${t("common.appName")} tema` } }}
        />
        <DarkModeRoundedIcon fontSize="small" aria-hidden />
      </Stack>
    </Tooltip>
  );
}
